import React from "react"
import { AbsoluteDateCalendar, AbsoluteCalendarProps } from "../AbsoluteCalendar";

type OptionalNumber = number | null

interface EditSelfReminderFormRepPatternMonthlyProps extends AbsoluteCalendarProps {
    isChecked: boolean,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
    targetDate: OptionalNumber,
    date: number,
    setDate: React.Dispatch<React.SetStateAction<number>>
}

const EditSelfReminderFormRepPatternMonthly: React.FC<EditSelfReminderFormRepPatternMonthlyProps> = ({
    isChecked, onChange,
    targetDate, date, setDate
}: EditSelfReminderFormRepPatternMonthlyProps) => {
    return (
        <label htmlFor="freq-monthly" className="flex flex-col p-3 border-2 border-b-0 rounded-t-xl items-left h-14 select-none radio-label-calendar">
            <div className="flex flex-row items-center">
                <input
                    type="radio" id="freq-monthly" name="frequency"
                    className="mr-2 label"
                    checked={isChecked}
                    onChange={onChange}
                />
                <span className="box-border block w-full text-lg font-light">เตือนเดือนละครั้ง</span>
            </div>
            <div className="flex flex-row items-center justify-center calendar-wrapper">
                <AbsoluteDateCalendar
                    targetDate={targetDate}
                    date={date}
                    setDate={setDate}
                />
            </div>
        </label>
    )
}

export default EditSelfReminderFormRepPatternMonthly;
export type { EditSelfReminderFormRepPatternMonthlyProps };